<div [formGroup]="optionsFg" class="main-container">
	<div></div>
	<mat-form-field style="margin-right: 20px; width: 320px">
		<mat-label>IRWIN ID</mat-label>
		<input matInput [formControl]="filterFg.get('irwinId')" />
		<mat-error *ngIf="filterFg.controls.irwinId?.hasError('invalidIrwinId')">
			Irwin id must be in the UUID format (EAA18302-B6C2-49C0-9332-B04A58C3CEC5)
		</mat-error>
	</mat-form-field>
	<div class="label">-OR-</div>
	<div class="details-container">
		<div [formGroup]="filterFg">
			<mat-form-field class="incidentDetails">
				<mat-label>Incident Name</mat-label>
				<input matInput formControlName="incidentName" />
			</mat-form-field>
			<mat-form-field class="incidentDetails">
				<mat-label>Unique Fire Identifier</mat-label>
				<input matInput formControlName="uniqueFireIdentifier" />
			</mat-form-field>
			<mat-form-field class="incidentDetails range-dropdown" [formGroup]="optionsFg">
				<mat-label>Incident Size</mat-label>
				<mat-select formControlName="incidentSizeType" canSelectNullableOptions>
					<mat-option *ngFor="let numberRange of sizeAndCostDropdownOptions" [value]="numberRange.value">{{ numberRange.label }}</mat-option>
					<mat-option [value]="null">No Selection</mat-option>
				</mat-select>
			</mat-form-field>
		</div>
		<div style="display: flex; flex-direction: column" [formGroup]="filterFg">
			<div [hidden]="this.hideField.incidentSizeMin">
				<mat-form-field>
					<mat-label>Acres</mat-label>
					<input matInput type="number" formControlName="incidentSizeMin" />
				</mat-form-field>
			</div>
			<div [hidden]="this.hideField.incidentSizeAnd" class="and">and</div>
			<div [hidden]="this.hideField.incidentSizeMax">
				<mat-form-field>
					<mat-label>Acres</mat-label>
					<input matInput type="number" formControlName="incidentSizeMax" />
				</mat-form-field>
			</div>
		</div>
		<div>
			<mat-form-field class="incidentDetails range-dropdown" [formGroup]="optionsFg">
				<mat-label>Estimated Final Cost (Last Published)</mat-label>
				<mat-select formControlName="estimatedFinalCostType" canSelectNullableOptions>
					<mat-option *ngFor="let numberRange of sizeAndCostDropdownOptions" [value]="numberRange.value">{{ numberRange.label }}</mat-option>
					<mat-option [value]="null">No Selection</mat-option>
				</mat-select>
			</mat-form-field>
		</div>
		<div>
			<div [formGroup]="filterFg">
				<div [hidden]="this.hideField.estimatedFinalCostMin">
					<mat-form-field class="incidentDetails">
						<mat-label>Dollars</mat-label>
						<input matInput wfdssCurrencyFormat formControlName="estimatedFinalCostMin" />
					</mat-form-field>
				</div>
				<div [hidden]="this.hideField.estimatedFinalCostMax">
					<div [hidden]="this.hideField.estimatedFinalCostAnd" class="and">and</div>
					<mat-form-field class="incidentDetails">
						<mat-label>Dollars</mat-label>
						<input matInput formControlName="estimatedFinalCostMax" wfdssCurrencyFormat />
					</mat-form-field>
				</div>
			</div>
		</div>
	</div>

	<div>
		<span class="label"> Filters </span>
	</div>
	<div style="display: flex; flex-direction: row">
		<div style="display: flex; flex-direction: row; margin-bottom: 25px; margin-right: 52px">
			<div [formGroup]="radiosFg">
				<mat-radio-group
					color="primary"
					style="display: flex; flex-direction: column; margin-right: 32px"
					class="flex-radio-group"
					formControlName="discoveryDateRadio"
					[attr.aria-label]="'discovery date filter selection'">
					<mat-radio-button [value]="'Any'"> Any Discovery Date </mat-radio-button>
					<mat-radio-button class="radio-option" [value]="'Discovered'"> Discovered </mat-radio-button>
				</mat-radio-group>
			</div>

			<div style="display: flex; flex-direction: row; align-items: center" [formGroup]="filterFg">
				<mat-form-field class="dropdown" [formGroup]="optionsFg">
					<mat-select formControlName="discoveryDateDropdown">
						<mat-option *ngFor="let dateRangeValue of dateDropdownOptions" [value]="dateRangeValue">{{ dateRangeValue }}</mat-option>
					</mat-select>
				</mat-form-field>
				<div style="margin-left: 5px">
					<div [hidden]="this.hideField.discoveredBetweenMin">
						<mat-form-field>
							<input matInput [matDatepicker]="datePickerDiscLower" formControlName="discoveredBetweenMin" />
							<mat-datepicker-toggle matSuffix [for]="datePickerDiscLower"></mat-datepicker-toggle>
							<mat-datepicker #datePickerDiscLower></mat-datepicker>
						</mat-form-field>
					</div>
					<div [hidden]="this.hideField.discoveredBetweenMax">
						<div class="and" [hidden]="this.hideField.discoveredBetweenMin">and</div>
						<mat-form-field>
							<input matInput [matDatepicker]="datePickerDiscUpper" formControlName="discoveredBetweenMax" />
							<mat-datepicker-toggle matSuffix [for]="datePickerDiscUpper"></mat-datepicker-toggle>
							<mat-datepicker #datePickerDiscUpper></mat-datepicker>
						</mat-form-field>
					</div>
				</div>
				<div [hidden]="this.hideField.discoveryDateOn">
					<mat-form-field>
						<input matInput [matDatepicker]="datePickerDiscOn" formControlName="discoveryDateOn" />
						<mat-datepicker-toggle matSuffix [for]="datePickerDiscOn"></mat-datepicker-toggle>
						<mat-datepicker #datePickerDiscOn></mat-datepicker>
					</mat-form-field>
				</div>
			</div>
		</div>
		<div style="display: flex; flex-direction: row">
			<div style="display: flex; flex-direction: row; margin-bottom: 25px; margin-right: 52px">
				<div [formGroup]="radiosFg">
					<mat-radio-group
						color="primary"
						style="display: flex; flex-direction: column; margin-right: 32px"
						class="flex-radio-group"
						formControlName="outDateRadio"
						[attr.aria-label]="'out date filter selection'">
						<mat-radio-button [value]="'Any'"> Any Out Date </mat-radio-button>
						<mat-radio-button class="radio-option" [value]="'Out'"> Out </mat-radio-button>
						<mat-radio-button class="radio-option" [value]="'None'"> No Out Date </mat-radio-button>
					</mat-radio-group>
				</div>
				<div style="display: flex; flex-direction: row; align-items: center" [formGroup]="filterFg">
					<mat-form-field class="dropdown" [formGroup]="optionsFg">
						<mat-select formControlName="outDateDropdown">
							<mat-option *ngFor="let dateRangeValue of outDateRangeValues" [value]="dateRangeValue">{{ dateRangeValue }}</mat-option>
						</mat-select>
					</mat-form-field>
					<div [hidden]="true" [formGroup]="this.filterFg">
						<!-- Need this to avoid missing control value accessor error. Hidden because it's updated programmatically when the 'No Out Date' radio is selected -->
						<mat-radio-group formControlName="fireOutDateNone"> </mat-radio-group>
					</div>
					<div style="margin-left: 5px">
						<div [hidden]="this.hideField.fireOutBetweenMin">
							<mat-form-field>
								<input matInput [matDatepicker]="datePickerOutLower" formControlName="fireOutBetweenMin" />
								<mat-datepicker-toggle matSuffix [for]="datePickerOutLower"></mat-datepicker-toggle>
								<mat-datepicker #datePickerOutLower></mat-datepicker>
							</mat-form-field>
						</div>
						<div [hidden]="this.hideField.fireOutBetweenMax">
							<div class="and" [hidden]="this.hideField.fireOutBetweenMin">and</div>
							<mat-form-field>
								<input matInput [matDatepicker]="datePickerOutUpper" formControlName="fireOutBetweenMax" />
								<mat-datepicker-toggle matSuffix [for]="datePickerOutUpper"></mat-datepicker-toggle>
								<mat-datepicker #datePickerOutUpper></mat-datepicker>
							</mat-form-field>
						</div>
					</div>
					<div [hidden]="this.hideField.fireOutDateOn">
						<mat-form-field>
							<input matInput [matDatepicker]="datePickerOutOn" formControlName="fireOutDateOn" />
							<mat-datepicker-toggle matSuffix [for]="datePickerOutOn"></mat-datepicker-toggle>
							<mat-datepicker #datePickerOutOn></mat-datepicker>
						</mat-form-field>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div>
		<div class="geographic-area" [formGroup]="filterFg">
			<div>
				<mat-form-field style="margin-right: 20px">
					<mat-label>Geographic Area</mat-label>
					<mat-select formControlName="geographicAreaIds" canSelectNullableOptions>
						<mat-option [value]="null">No Selection</mat-option>
						<mat-option *ngFor="let geographicArea of geographicAreasList$ | async" [value]="geographicArea.geographicAreaId">{{
							geographicArea.shortName
						}}</mat-option>
					</mat-select>
				</mat-form-field>
			</div>
			<div>
				<mat-form-field style="margin-right: 16px">
					<mat-label>State</mat-label>
					<mat-select formControlName="pooStates" canSelectNullableOptions>
						<mat-option [value]="null">No Selection</mat-option>
						<mat-option *ngFor="let state of statesList$ | async" [value]="state">{{ state }}</mat-option>
					</mat-select>
				</mat-form-field>
			</div>
			<div>
				<mat-form-field style="margin-right: 20px">
					<mat-label>Jurisdictional Agency</mat-label>
					<mat-select formControlName="jurisdicitonalAgencyAtPooId" canSelectNullableOptions>
						<mat-option [value]="null">No Selection</mat-option>
						<mat-option *ngFor="let agency of agenciesList$ | async" [value]="agency.jurisdictionalAgencyId">{{ agency.shortName }}</mat-option>
					</mat-select>
				</mat-form-field>
			</div>
			<div>
				<mat-form-field style="width: 400px; margin-right: 16px">
					<mat-label>Jurisdictional Unit</mat-label>

					<mat-select formControlName="jurisdicitonalUnitId" canSelectNullableOptions>
						<mat-option [value]="null">No Selection</mat-option>
						<mat-option *ngFor="let unit of unitsList$ | async" [value]="unit.unitId" [disabled]="noJurisdictionSelection"
							>{{ unit.unitIrwinId }} - {{ unit.name }}
						</mat-option>
					</mat-select>
				</mat-form-field>
			</div>

			<div>
				<mat-form-field style="width: 400px">
					<mat-label>Protecting Unit</mat-label>
					<mat-select formControlName="protectingUnitId" canSelectNullableOptions>
						<mat-option [value]="null">No Selection</mat-option>
						<mat-option *ngFor="let unit of unitsList$ | async" [value]="unit.unitId" [disabled]="noProtectingUnitSelection"
							>{{ unit.unitIrwinId }} - {{ unit.name }}
						</mat-option>
					</mat-select>
				</mat-form-field>
			</div>
		</div>
	</div>
	<button class="primary-button" (click)="onSearch()">Search</button>
</div>
<div style="display: flex; justify-content: space-between">
	<div></div>
	<wfdss-export-button style="display: flex" (click)="download()"></wfdss-export-button>
</div>
<div id="li-table" style="margin: 0px 30px">
	<table
		mat-table
		class="app-table"
		[dataSource]="tableDataSource"
		style="width: 100%"
		[fixedLayout]="fixedLayout"
		matSort
		[matSortActive]="sortActive"
		[matSortDirection]="sortDirection"
		[matSortDisableClear]="true"
		aria-describedby="Wfdss Case Records Table">
		<ng-container matColumnDef="Incident Name">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>Incident Name</th>
			<td *matCellDef="let row" mat-cell style="cursor: pointer">
				<a (click)="onClickIncident(row)">{{ row.name }}</a>
			</td>
		</ng-container>
		<ng-container matColumnDef="Unique Fire Identifier">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>Unique Fire Identifier</th>
			<td *matCellDef="let row" mat-cell>{{ row.uniqueFireIdentifier }}</td>
		</ng-container>
		<ng-container matColumnDef="Geographic Area">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>Geographic Area</th>
			<td *matCellDef="let row" mat-cell>{{ row?.geographicArea?.shortName }}</td>
		</ng-container>
		<ng-container matColumnDef="Jurisdiction(s)">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>Jurisdiction</th>
			<td *matCellDef="let row" mat-cell>{{ row.jurisdictionalAgencyAtPoO?.shortName }}</td>
		</ng-container>
		<ng-container matColumnDef="Protecting Unit">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>Protecting Unit</th>
			<td *matCellDef="let row" mat-cell> {{row | protectingUnit}}</td>
		</ng-container>
		<ng-container matColumnDef="State">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>State</th>
			<td *matCellDef="let row" mat-cell>{{ row.pooState }}</td>
		</ng-container>
		<ng-container matColumnDef="Size (Acres)">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>Size (Acres)</th>
			<td *matCellDef="let row" mat-cell>{{ row.incidentSize }}</td>
		</ng-container>
		<ng-container matColumnDef="Discovery Date/Time">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>Discovery Date/Time</th>
			<td *matCellDef="let row" mat-cell>{{ row.fireDiscoveryDateTime | unixToMomentDate : "MM/DD/YYYY HH:mm" }}</td>
		</ng-container>
		<tr mat-header-row *matHeaderRowDef="columns"></tr>
		<tr tabindex="0" mat-row *matRowDef="let row; columns: columns"></tr>
	</table>
	<mat-paginator [pageSizeOptions]="[10, 20]" [pageSize]="defaultPageSize" #paginator></mat-paginator>
</div>
